import React, { useState } from 'react';

import { Typography } from 'antd';

export function HoverCopy({ text }) {
  const [show, setShow] = useState(false);
  const onMouseEnter = () => setShow(true);
  const onMouseLeave = () => setShow(false);
  if (show) {
    return (
      <Typography.Paragraph onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} copyable>
        {text}
      </Typography.Paragraph>
    );
  }
  return (
    <Typography.Paragraph onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {text}
    </Typography.Paragraph>
  );
}
